import * as $ajax from './_ajax'
import * as $msg from './_msg'
import * as $loading from './_loading'
import * as $blogpostpopup from './blog.blogpostpopup'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
}

var options: IInitOptions
var filesToUpload: number = 0
var uploadErrors: string[] = []
var currentSort: number = 0
var sortAsc: boolean = true

export function init($options: IInitOptions): void {
    options = $options

    $('.' + options.pagePrefix + '-showonmap').click(function () {
        const ids: string[] = []

        $('#' + options.pagePrefix + '-owner-list .check').each(function () {
            if ($(this).prop('checked')) {
                ids.push($(this).attr('data-id'))
            }
        })

        if (!ids || ids.length <= 0) return

        $loading.show()

        $('.' + options.pagePrefix + '-map').load('/Flag/ShowOnMap?flagIds=' + ids.join(','), function () {
            $loading.hide()
        })
    })

    $('#' + options.pagePrefix + '-owner-add-btn').click(function () {
        var tb = $('#' + options.pagePrefix + '-owner-add-tb')
        var val = tb.val()
        if (!val || val.length === 0) {
            $msg.showError('Namn saknas')
            return
        }

        $ajax.post({
            loadingText: 'Skapar...',
            url: '/Flag/Create',
            data: {
                name: tb.val(),
                property: false,
            },
            success: function (res) {
                if (res.Ok) {
                    tb.val('')
                    getLists()
                } else {
                    $msg.showError(res.Message)
                }
            },
        })
    })

    $('#' + options.pagePrefix + '-prop-add-btn').click(function () {
        var tb = $('#' + options.pagePrefix + '-prop-add-tb')
        var val = tb.val()
        if (!val || val.length === 0) {
            $msg.showError('Namn saknas')
            return
        }

        $ajax.post({
            loadingText: 'Skapar...',
            url: '/Flag/Create',
            data: {
                name: tb.val(),
                property: true,
            },
            success: function (res) {
                if (res.Ok) {
                    tb.val('')
                    getLists()
                } else {
                    $msg.showError(res.Message)
                }
            },
        })
    })

    // owner file upload
    $('#' + options.pagePrefix + '-filer-upload-result-hide').click(function () {
        uploadShowUpload('filer')
        getLists()
    })
    $('#' + options.pagePrefix + '-filer-upload-files').fileupload({
        dataType: 'json',
        sequentialUploads: false,
        add: function (e, data) {
            filesToUpload++
            $loading.show('Laddar upp fil...')
            uploadShowProgress('filer')
            data.process().done(function () {
                data.submit()
            })
        },
        fail: function (e, data) {
            uploadErrors.push(data.errorThrown)
        },
        progressall: function (e, data) {
            var progress = (data.loaded / data.total) * 100
            uploadSetProgress('filer', progress)
        },
        always: function (e, data) {
            if (data.result[0].error) uploadErrors.push(data.result[0].error)
            filesToUpload--
            $loading.hide()
            finishOwnerUpload()
        },
    })

    // property file upload
    $('#' + options.pagePrefix + '-propfile-upload-result-hide').click(function () {
        uploadShowUpload('propfile')
        getLists()
    })
    $('#' + options.pagePrefix + '-propfile-upload-files').fileupload({
        dataType: 'json',
        sequentialUploads: false,
        add: function (e, data) {
            filesToUpload++
            $loading.show('Laddar upp fil...')
            uploadShowProgress('propfile')
            data.process().done(function () {
                data.submit()
            })
        },
        fail: function (e, data) {
            uploadErrors.push(data.errorThrown)
        },
        progressall: function (e, data) {
            var progress = (data.loaded / data.total) * 100
            uploadSetProgress('propfile', progress)
        },
        always: function (e, data) {
            if (data.result[0].error) uploadErrors.push(data.result[0].error)
            filesToUpload--
            $loading.hide()
            finishPropertyUpload()
        },
    })

    $blogpostpopup.load(5)
}

function finishOwnerUpload(): void {
    if (filesToUpload > 0) return

    if (uploadErrors.length > 0) {
        uploadShowResult('filer', 'Fel vid uppladdning', uploadErrors.join('</p><p>'))
    } else {
        uploadShowImporting('filer')
        $ajax.post({
            loadingText: 'Importerar fil...',
            url: '/Flag/DoImportOwners',
            data: {
                flag: $('#' + options.pagePrefix + '-filer-upload-flag').val(),
                key: $('#' + options.pagePrefix + '-filer-upload-key .bcfla-checked').attr('data-value'),
                replace: $('#' + options.pagePrefix + '-filer-upload-replace .bcfla-checked').attr('data-value'),
            },
            success: function (res) {
                uploadShowResult('filer', res.Header, res.Description)
                getLists()
            },
        })
    }

    uploadErrors = []
    filesToUpload = 0
    uploadSetProgress('filer', 0)
}

function finishPropertyUpload(): void {
    if (filesToUpload > 0) return

    if (uploadErrors.length > 0) {
        uploadShowResult('propfile', 'Fel vid uppladdning', uploadErrors.join('</p><p>'))
    } else {
        uploadShowImporting('propfile')
        $ajax.post({
            loadingText: 'Importerar fil...',
            url: '/Flag/DoImportProperties',
            data: {
                flag: $('#' + options.pagePrefix + '-propfile-upload-flag').val(),
                columns: $('#' + options.pagePrefix + '-propfile-upload-columns .bcfla-checked').attr('data-value'),
                headers: $('#' + options.pagePrefix + '-propfile-upload-headers .bcfla-checked').attr('data-value'),
                replace: $('#' + options.pagePrefix + '-propfile-upload-replace .bcfla-checked').attr('data-value'),
            },
            success: function (res) {
                uploadShowResult('propfile', res.Header, res.Description)
                getLists()
            },
        })
    }

    uploadErrors = []
    filesToUpload = 0
    uploadSetProgress('propfile', 0)
}

function uploadSetProgress(prefix: string, progress: number): void {
    $('#' + options.pagePrefix + '-' + prefix + '-upload-progress .progress-bar').attr('aria-valuenow', progress)
    $('#' + options.pagePrefix + '-' + prefix + '-upload-progress .progress-bar').css('width', progress + '%')
}

function uploadShowResult(prefix: string, header: string, description: string): void {
    $('#' + options.pagePrefix + '-' + prefix + '-upload-files-plh').addClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-progress-plh').addClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-importing-plh').addClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-result').removeClass('bcfla-hidden')

    $('#' + options.pagePrefix + '-' + prefix + '-upload-result-header').html(header)
    $('#' + options.pagePrefix + '-' + prefix + '-upload-result-description').html(description)
}

function uploadShowProgress(prefix: string): void {
    $('#' + options.pagePrefix + '-' + prefix + '-upload-files-plh').addClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-progress-plh').removeClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-importing-plh').addClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-result').addClass('bcfla-hidden')
}

function uploadShowImporting(prefix: string): void {
    $('#' + options.pagePrefix + '-' + prefix + '-upload-files-plh').addClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-progress-plh').addClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-importing-plh').removeClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-result').addClass('bcfla-hidden')
}

function uploadShowUpload(prefix: string): void {
    $('#' + options.pagePrefix + '-' + prefix + '-upload-files-plh').removeClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-progress-plh').addClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-importing-plh').addClass('bcfla-hidden')
    $('#' + options.pagePrefix + '-' + prefix + '-upload-result').addClass('bcfla-hidden')
}

function getLists(): void {
    $('#' + options.pagePrefix + '-owner-list').load('/Flag/EditOwner?sort=' + currentSort + '&asc=' + sortAsc)
    $('#' + options.pagePrefix + '-prop-list').load('/Flag/EditProperty?sort=' + currentSort + '&asc=' + sortAsc)
}

export function sortList(sort: string): void {
    var newSort = parseInt(sort)
    if (newSort === currentSort) {
        sortAsc = !sortAsc
    } else {
        sortAsc = true
    }
    currentSort = newSort
    getLists()
}

function updateUploadSelect(): void {
    const list: string[][] = []

    $('#' + options.pagePrefix + '-owner-list input.bcfla-pfeo-name-tb').each((_, el) => {
        list.push([$(el).val(), `<option value="${$(el).attr('data-id')}">${$(el).val()}</option>`])
    })

    list.sort((a, b) => (a[0] > b[0] ? 1 : b[0] > a[0] ? -1 : 0))

    $('#' + options.pagePrefix + '-filer-upload-flag').html(list.map((a) => a[1]).join(''))
}

export function flagsChanged(): void {
    if (!options) return
    updateUploadSelect()
}
